export class FeaturesApi {
    #client;

    /**
     * @param {ServerData} client
     * */
    constructor(client) {
        this.#client = client;
    }

    /**
     * @param {FeatureOwnerTypeValue} entityType
     * @param {number} entityId
     * @param {string} featureName
     * @param {string|number|boolean} value
     * @return {Promise<FeatureValue>}
     * */
    setFeatureForEntity(entityType, entityId, featureName, value) {
        return this.#client.put(`/managers/features/${entityType}/${entityId}/${featureName}`, { value });
    }

    /**
     * @param {FeatureOwnerTypeValue} entityType
     * @param {number} entityId
     * @param {string} featureName
     * @param {boolean} ignoreBrowserCache
     * @return {Promise<FeatureValue | null>}
     * */
    getFeatureForEntity(entityType, entityId, featureName, ignoreBrowserCache) {
        const params = ignoreBrowserCache ? { t: String(Date.now()) } : {};
        return this.#client.get(`/managers/features/${entityType}/${entityId}/${featureName}`, params);
    }

    // Commented out: no callers left. Its only user was partnerSidebarGroup, which sent one request per building
    // (155 buildings -> 310 requests incl. CORS preflights on every app load) to learn if bllinkMaintenance is on
    // for at least one building. Use getFeatureForAnyUserBuilding (one request) instead. Do not bring back a
    // per-entity fan-out - if a batch of entities is needed, add a backend endpoint that answers it in one query.
    // getFeatureForEntitys(list, ignoreBrowserCache) {
    //     const params = ignoreBrowserCache ? { t: String(Date.now()) } : {};
    //
    //     const requests = list.map(async (item) => {
    //         const { entityType, entityId, featureName } = item;
    //         return await this.#client.get(`/managers/features/${entityType}/${entityId}/${featureName}`, params);
    //     });
    //
    //     return Promise.all(requests);
    // }

    /**
     * Is the feature 'true' for at least one of the current user's buildings - one request instead of one per building.
     * Background check - avoidError so a failure does not pop an error to the user (the error is returned instead).
     * @param {string} featureName
     * @return {Promise<{value: boolean}>}
     * */
    getFeatureForAnyUserBuilding(featureName) {
        return this.#client.get(`/managers/features-summary/buildings/${featureName}`, {}, { avoidError: true });
    }
}
